import { Box, Grid, Paper, Typography, Button, Table, TableHead, TableRow, TableBody, TableCell } from '@material-ui/core';
import { observer } from 'mobx-react';
import React, { useEffect, useRef } from 'react';
import { useHistory, Link } from 'react-router-dom';
import DiscountCard from '../../components/Cards/DiscountCard';
import NextLevel from '../../components/Cards/NextLevel';
import NextLevelPoints from '../../components/Cards/NextLevelPoints';
import Loader from '../../components/Loader';
import LoyaltyFaq from '../../components/Loyalty/LoyaltyFaq';
import PageSubTitle from '../../components/UI/PageSubTitle';
import { useStores } from '../../hooks/use-stores';
import { scrollTo } from '../../utils/scrollTo';
import PointsValue from '../../components/UI/PointsValue';

const Loyalty = observer(() => {
    const history = useHistory();
    const { LoyaltyStore: store } = useStores();
    const loyaltyLevelsAnchor = useRef(null);
    const loyaltyHistoryAnchor = useRef(null);
    const privilageAnchor = useRef(null);

    // Effects
    useEffect(() => {
        store.getPrivileges();
        store.getBonusGetInfo();
        store.getBonusHistory();
    }, [store]);

    useEffect(() => {
        const clearHash = () => {
            history.replace(history.location.pathname);
        };

        if (!store.loading && history.location.hash) {
            switch (history.location.hash) {
                case '#privilage':
                    scrollTo(privilageAnchor?.current, 300);
                    clearHash();
                    break;
                case '#faq':
                    scrollTo(loyaltyHistoryAnchor?.current, 300);
                    clearHash();
                    break;

                default:
                    break;
            }
        }
    }, [history, history.location, store.loading]);

    // Renders
    return (
        <>
            <Box mb={7}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={4}>
                        <DiscountCard type="current" withRequest />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <NextLevelPoints />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <NextLevel />
                    </Grid>
                </Grid>
            </Box>

            <Box>
                <PageSubTitle>Ваш уровень</PageSubTitle>
                {store.loading && <Loader />}
                {!store.loading && store.levels?.length ? (
                    <div className="privilege privilege--v2 mb-60">
                        <div className="privilege__col">
                            <div className="privilege-type">
                                <div className="privilege-type__icon">
                                    <img src={store.userLevelInfo?.image_available} alt="" className="sprite-icon" />
                                </div>
                                <div className="privilege-type__text">
                                    <div className="privilege-type__title">{store.userLevelInfo?.name}</div>
                                    <div className="privilege-type__desc">{store.userLevelInfo?.points} баллов</div>
                                </div>
                            </div>
                        </div>
                        <div className="privilege__col">
                            <div className="privilege__desc">
                                <p>{store.userLevelInfo?.level_description}</p>
                            </div>
                        </div>
                    </div>
                ) : null}
            </Box>

            <Box mb={7.5} ref={privilageAnchor}>
                <PageSubTitle>Привилегии</PageSubTitle>

                {store.loading && <Loader />}
                {!store.loading && store.levels?.length ? (
                    <div className="privilege-list">
                        {store.privileges.map(({ id, is_available, name }) => (
                            <div className="privilege-list__col" key={id}>
                                <div className={`privilege-card${is_available ? '' : ' privilege-card--disabled'}`}>
                                    <div className="privilege-card__text">{name}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : null}
            </Box>

            <Box mb={7.5}>
                <PageSubTitle>история баллов</PageSubTitle>
                <Paper>
                    <Box p={4} pt={0}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Номер</TableCell>
                                    <TableCell>Техника</TableCell>
                                    <TableCell>Баллы</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {store.loading && <Loader />}
                                {!store.loading && store.bonusHistory?.length ? (
                                    <>
                                        {store.bonusHistory.map(item => (
                                            <TableRow>
                                                <TableCell>{item.id}</TableCell>
                                                <TableCell>{item.type_equipment || item.name}</TableCell>
                                                <TableCell>
                                                    {item.add_points > 0 && <PointsValue>+ {item.add_points}</PointsValue>}
                                                    {item['written-off_points'] > 0 && (
                                                        <PointsValue classname="pointsNegative">- {item['written-off_point']}</PointsValue>
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </>
                                ) : null}
                            </TableBody>
                        </Table>
                    </Box>
                </Paper>
            </Box>

            <Box mb={7.5} ref={loyaltyHistoryAnchor}>
                <LoyaltyFaq title="как получить баллы?" isExpanded={history.location.state?.activeTabID === 0}>
                    <Box>
                        <Typography>
                            Копить баллы очень просто! Арендуйте или приобретайте технику. Баллы начисляются автоматически!
                        </Typography>
                        <br />
                        {store.loading && <Loader />}
                        {!store.loading && (
                            <Box>
                                <Box mb={2}>
                                    <Typography component="div" dangerouslySetInnerHTML={{ __html: store.bonusGetInfo?.description }} />
                                </Box>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Категория</TableCell>
                                            <TableCell>Баллы</TableCell>
                                            <TableCell style={{ width: 125 }} />
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {store.bonusGetInfo?.items?.map(item => (
                                            <TableRow>
                                                <TableCell>{item.name}</TableCell>
                                                <TableCell>
                                                    <PointsValue>{item.points}</PointsValue>
                                                </TableCell>
                                                <TableCell>
                                                    <Link to={`/catalog/${item.category_id}`}>
                                                        <Button variant="outlined" color="primary" size="small">
                                                            Перейти
                                                        </Button>
                                                    </Link>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </Box>
                        )}
                    </Box>
                </LoyaltyFaq>
                <LoyaltyFaq title="как потратить баллы?" isExpanded={history.location.state?.activeTabID === 1}>
                    <Box>
                        <Typography>Вы можете оплатить баллами:</Typography>
                        <Box mb={3}>
                            <ul>
                                <li>от 30% до 50% стоимости аренды оборудования;</li>
                                <li>до 20% при покупке оборудования, которое участвует в акции;</li>
                                <li>доставку полностью или частично в зависимости от вашего региона.</li>
                            </ul>
                        </Box>
                        <Link to="/catalog">
                            <Button variant="outlined" color="primary">
                                Перейти к каталогу
                            </Button>
                        </Link>
                    </Box>
                </LoyaltyFaq>
            </Box>

            {/* For scroll */}
            <div ref={loyaltyLevelsAnchor}>&nbsp;</div>
        </>
    );
});

export default Loyalty;
